let eventGuid = 0
const todayStr = new Date().toISOString().replace(/T.*$/, '') // YYYY-MM-DD of today

export const INITIAL_EVENTS = [
  {
    id: createEventId(),
    title: 'All-day event',
    start: todayStr,
    eventColor:'#000000',
    location:'Kolkata',
    end:todayStr

  }
]

export function createEventId () {
  return String(eventGuid++)
}